import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import { FormLabel, FormGroup } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import CheckBox from "../Forms/CheckboxWithLabel";

import { styles } from "./styles";

const CheckTypeFilter = (props) => {
  const { classes, onSearchCriteriaChange } = props;
  const { t } = useTranslation();
  const [kycChecked, setKycChecked] = useState(true);
  const [amlChecked, setAmlChecked] = useState(true);

  const handleKycChange = async (e) => {
    setKycChecked(e.target.checked);
    const checkTypes = [];
    if (e.target.checked) {
      checkTypes.push("KYC");
    }
    if (amlChecked) {
      checkTypes.push("AML");
    }
    if (onSearchCriteriaChange) {
      onSearchCriteriaChange({ checkTypes });
    }
  };

  const handleAmlChange = async (e) => {
    setAmlChecked(e.target.checked);
    const checkTypes = [];
    if (e.target.checked) {
      checkTypes.push("AML");
    }
    if (kycChecked) {
      checkTypes.push("KYC");
    }
    if (onSearchCriteriaChange) {
      onSearchCriteriaChange({ checkTypes });
    }
  };

  return (
    <div className={classes.filterContainer}>
      <FormLabel className={classes.headerLabel}>{t("labels.filter.byCheckType")}</FormLabel>
      <FormGroup>
        <div className={classes.checkBoxContainer}>
          <CheckBox
            label={t("labels.checks.KYC")}
            onChange={handleKycChange}
            value={kycChecked}
          />
        </div>
        <div className={classes.checkBoxContainer}>
          <CheckBox
            label={t("labels.checks.AML")}
            onChange={handleAmlChange}
            value={amlChecked}
          />
        </div>
      </FormGroup>
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(CheckTypeFilter);
